<script lang="ts">
  import { TeoCore } from '@/teoCore/TeoCore';
  import VStack from '@/ui/base/stack/VStack.svelte';
  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import LinkButton from '@/ui/elements/buttons/LinkButton.svelte';

  import { useAuthActions } from '../../use-auth.svelte';

  let { message }: { message?: string | null } = $props();

  const { logOut } = useAuthActions();
</script>

<VStack class="w-[320px]" gap={4} xalign="center">
  <h1 class="text-[20px] font-bold text-c-error">Fehler:</h1>
  <p class="text-lg text-center">
    {message ?? 'Die Anwendung konnte nicht geladen werden.'}
  </p>
  <CtaButton class="self-stretch" onclick={() => TeoCore.instance.retryBootstrap()}>
    Erneut versuchen
  </CtaButton>
  <LinkButton highlight type="button" onclick={() => logOut()}>Abmelden</LinkButton>
</VStack>
